// Textos de Bônus e adicionais (31/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.bonus.titulo': 'Bônus e adicionais',
    'dp.bonus.eyebrow': 'Departamento Pessoal',
    'dp.bonus.apurar': 'Apurar',
    'dp.bonus.reapurar': 'Reapurar',
    'dp.bonus.apurada': 'Apuração feita: {{novas}} novas, {{recalculadas}} recalculadas.',
    'dp.bonus.naoApurada': 'A competência {{rotulo}} ainda não foi apurada. Apurar junta as medições de colheita, a jornada, a diária do Protheus, as Gestões, as multas, os sinistros e o espelho de {{espelho}}, e monta o bônus do operador e os adicionais de prancha, sinistro, manobra e eixos.',
    'dp.bonus.explica': 'Bônus do operador pela cláusula 4 do acordo coletivo: hectares colhidos vezes o valor por hectare do modelo da máquina, zerado por requisito não cumprido. Adicionais de prancha, sinistro e manobra de {{adicional}}, cheios com {{cheio}} dias seguidos fora da base e proporcionais abaixo disso. Adicional de {{eixosMinimo}} eixos pela cláusula 3.',
    'dp.bonus.semTabela': 'A tabela de valor por hectare está vazia. O bônus do operador fica em zero até o DP cadastrar o valor de cada modelo em Valores e reapurar.',
    'dp.bonus.semEspelho': 'O espelho de {{espelho}} não está no Hub, então ninguém foi derrubado pelo ponto. Abra a competência na Assinatura do ponto e reapure.',
    'dp.bonus.antesDoPrazo': 'Até {{prazo}}, quem ainda não assinou o espelho de {{espelho}} aparece sem o bônus. Reapure depois do prazo.',
    'dp.bonus.kpi.total': 'Total a pagar',
    'dp.bonus.kpi.linhas': 'Linhas',
    'dp.bonus.kpi.linhasDica': '{{pessoas}} pessoas',
    'dp.bonus.kpi.zeradas': 'Zeradas por requisito',
    'dp.bonus.kpi.ajustes': 'Ajustes manuais',
    'dp.bonus.kpi.sinistros': 'Sinistros informados',
    'dp.bonus.kpi.semValor': 'Sem valor para a máquina',
    'dp.bonus.porTipo': 'Por tipo',
    'dp.bonus.porFilial': 'Por filial',
    'dp.bonus.requisitosNaoCumpridos': 'Requisitos não cumpridos',
    'dp.bonus.todosCumpridos': 'Requisitos cumpridos',
    'dp.bonus.col.pessoa': 'Pessoa',
    'dp.bonus.col.tipo': 'Tipo',
    'dp.bonus.col.requisitos': 'Requisitos',
    'dp.bonus.col.valor': 'Valor',
    'dp.bonus.col.acoes': 'Ações',
    'dp.bonus.todosOsTipos': 'Todos os tipos',
    'dp.bonus.tipo.operador_hectare': 'Bônus do operador',
    'dp.bonus.tipo.adicional_prancha': 'Adicional de prancha',
    'dp.bonus.tipo.adicional_sinistro': 'Adicional de sinistro',
    'dp.bonus.tipo.adicional_manobra': 'Adicional de manobra',
    'dp.bonus.tipo.adicional_eixos': 'Adicional de {{eixosMinimo}} eixos',
    'dp.bonus.hectares': '{{n}} ha',
    'dp.bonus.diasSeguidos': '{{n}} dias seguidos fora da base',
    'dp.bonus.diasEixos': '{{n}} dias com {{eixosMinimo}} eixos ou mais',
    'dp.bonus.semValorModelo': 'Sem valor para {{modelos}}',
    'dp.bonus.requisito.ponto_assinado': 'Espelho não assinado',
    'dp.bonus.requisito.sem_falta': 'Falta',
    'dp.bonus.requisito.sem_suspensao': 'Suspensão',
    'dp.bonus.requisito.sem_infracao_jornada': 'Infração de jornada',
    'dp.bonus.requisito.sem_multa': 'Multa de trânsito',
    'dp.bonus.requisito.sem_sinistro': 'Sinistro',
    'dp.bonus.requisito.eixos_cadastrados': 'Eixos sem cadastro',
    'dp.bonus.requisitoCumprido.ponto_assinado': 'Espelho de ponto assinado',
    'dp.bonus.requisitoCumprido.sem_falta': 'Sem falta injustificada',
    'dp.bonus.requisitoCumprido.sem_suspensao': 'Sem suspensão',
    'dp.bonus.requisitoCumprido.sem_infracao_jornada': 'Sem infração de jornada',
    'dp.bonus.requisitoCumprido.sem_multa': 'Sem multa de trânsito',
    'dp.bonus.requisitoCumprido.sem_sinistro': 'Sem sinistro',
    'dp.bonus.requisitoCumprido.eixos_cadastrados': 'Eixos do veículo cadastrados',
    'dp.bonus.fonte': 'Fonte {{fonte}}',
    'dp.bonus.calculado': 'Calculado {{valor}}',
    'dp.bonus.ajustado': 'Ajustado',
    'dp.bonus.sinistro': 'Sinistro informado',
    'dp.bonus.ajustar': 'Ajustar',
    'dp.bonus.memoria': 'Cálculo',
    'dp.bonus.valores': 'Valores',
    'dp.bonus.valoresDica': 'A tabela de valor por hectare por máquina, com vigência',
    'dp.bonus.ajusteTitulo': 'Ajuste de {{nome}}',
    'dp.bonus.ajusteTipo': '{{tipo}} de {{rotulo}}',
    'dp.bonus.ajusteSinistro': 'Sinistro informado pelo DP',
    'dp.bonus.ajusteSinistroExplica': 'O sinistro lançado pelo Abastecimento com o responsável motorista já derruba o requisito sozinho. Esta marcação é para o que ainda não foi lançado: vale para a pessoa inteira na competência, zera o bônus do operador e o adicional de sinistro, e sobrevive à reapuração. Tirar a marcação não apaga o sinistro lançado.',
    'dp.bonus.ajusteValor': 'Valor a pagar',
    'dp.bonus.ajusteJustificativa': 'Justificativa',
    'dp.bonus.ajusteExplica': 'O valor ajustado substitui o calculado e sobrevive à reapuração. Deixe em branco para voltar ao calculado.',
    'dp.bonus.ajusteSalvar': 'Salvar ajuste',
    'dp.bonus.memoriaTitulo': 'Cálculo de {{nome}}',
    'dp.bonus.memoria.tipo': 'Tipo',
    'dp.bonus.memoria.conta': 'Conta',
    'dp.bonus.memoria.requisitos': 'Requisitos',
    'dp.bonus.memoria.colheitas': 'Colheitas no período',
    'dp.bonus.memoria.semColheita': 'Nenhuma medição de colheita no período',
    'dp.bonus.memoria.hectares': 'Hectares',
    'dp.bonus.memoria.valorHectare': 'Valor por hectare',
    'dp.bonus.memoria.semValorModelo': 'Sem valor para a máquina',
    'dp.bonus.memoria.sequencias': 'Sequências fora da base',
    'dp.bonus.memoria.maiorSequencia': 'Maior sequência',
    'dp.bonus.memoria.diasN': '{{n}} dias',
    'dp.bonus.memoria.regra': 'Cheio com {{cheio}} dias seguidos; abaixo, dias sobre {{base}}',
    'dp.bonus.memoria.dias': 'Dia a dia',
    'dp.bonus.memoria.conta_sim': 'Conta',
    'dp.bonus.memoria.conta_nao': 'Zera',
    'dp.bonus.memoria.jornadas': 'Jornadas por veículo',
    'dp.bonus.memoria.eixosN': '{{n}} eixos',
    'dp.bonus.memoria.eixosSem': 'Eixos sem cadastro',
    'dp.bonus.memoria.valorBruto': 'Valor antes dos requisitos',
    'dp.bonus.memoria.ajuste': 'Ajuste manual',
    'dp.bonus.memoria.final': 'Valor final',
    'dp.bonus.memoria.fontes': 'Fontes',
    'dp.bonus.memoria.fonteColheita': 'Colheita',
    'dp.bonus.memoria.espelho': 'Espelho de {{rotulo}}',
    'dp.bonus.memoria.espelhoConferido': 'Conferido no Hub',
    'dp.bonus.memoria.espelhoNaoConferido': 'Não está no Hub',
    'dp.bonus.valoresTitulo': 'Valor por hectare por máquina',
    'dp.bonus.valoresExplica': 'O valor que cada hectare colhido paga ao operador, por máquina, pelo número do ativo, como MAQ0039. A máquina sem linha própria usa o valor do modelo, se houver. A vigência diz de quando a quando o valor vale; a linha sem fim é a em vigor.',
    'dp.bonus.valoresVazia': 'Nenhum valor cadastrado. O bônus do operador fica em zero até a tabela chegar.',
    'dp.bonus.valores.modelo': 'Máquina ou modelo',
    'dp.bonus.valores.modeloDaFrota': 'Modelo da frota',
    'dp.bonus.valores.modeloLivre': 'Máquina pelo número do ativo',
    'dp.bonus.valores.veiculosN': '{{n}} máquinas',
    'dp.bonus.valores.valor': 'Valor por hectare',
    'dp.bonus.valores.inicio': 'Início da vigência',
    'dp.bonus.valores.fim': 'Fim da vigência',
    'dp.bonus.valores.observacao': 'Observação',
    'dp.bonus.valores.vigente': 'Em vigor',
    'dp.bonus.valores.encerrado': 'Encerrado',
    'dp.bonus.valores.novo': 'Novo valor',
    'dp.bonus.valores.editar': 'Editar',
    'dp.bonus.valores.retirar': 'Retirar',
    'dp.bonus.valores.salvar': 'Salvar valor',
    'dp.bonus.valores.cancelar': 'Cancelar edição',
    'dp.bonus.valores.ate': 'até {{data}}',
    'dp.bonus.valores.desde': 'desde {{data}}',
    'dp.bonus.valores.lista': 'Valores cadastrados',
    'dp.bonus.valores.importar': 'Importar planilha',
    'dp.bonus.valores.importarTitulo': 'Importar a tabela de valor por hectare',
    'dp.bonus.valores.importarExplica': 'A planilha do DP com o número do ativo de cada máquina e o valor por hectare, já com a assiduidade. Cada máquina ganha o valor a partir de 16/09/2026, o primeiro ciclo do bônus. A máquina que já tem valor nesse início tem o valor trocado.',
    'dp.bonus.valores.carga.maquinas': 'Máquinas',
    'dp.bonus.valores.carga.minimo': 'Menor valor',
    'dp.bonus.valores.carga.maximo': 'Maior valor',
  },
  en: {
    'dp.bonus.titulo': 'Bonuses and allowances',
    'dp.bonus.eyebrow': 'Personnel Department',
    'dp.bonus.apurar': 'Calculate',
    'dp.bonus.reapurar': 'Recalculate',
    'dp.bonus.apurada': 'Calculated: {{novas}} new, {{recalculadas}} recalculated.',
    'dp.bonus.naoApurada': 'The {{rotulo}} pay period has not been calculated yet. Calculating gathers harvest measurements, working hours, Protheus daily records, Warnings, fines, claims and the {{espelho}} timesheet, and builds the operator bonus and the flatbed, accident, yard and axle allowances.',
    'dp.bonus.explica': 'Operator bonus under clause 4 of the collective agreement: hectares harvested times the per-hectare value of the machine model, zeroed by an unmet requirement. Flatbed, accident and yard allowances of {{adicional}}, full with {{cheio}} consecutive days away from base and proportional below that. {{eixosMinimo}}-axle allowance under clause 3.',
    'dp.bonus.semTabela': 'The per-hectare value table is empty. The operator bonus stays at zero until the department registers the value of each model in Values and recalculates.',
    'dp.bonus.semEspelho': 'The {{espelho}} timesheet is not in the Hub, so nobody lost the bonus for the timesheet. Open the pay period in Timesheet signature and recalculate.',
    'dp.bonus.antesDoPrazo': 'Until {{prazo}}, whoever has not signed the {{espelho}} timesheet shows without the bonus. Recalculate after the deadline.',
    'dp.bonus.kpi.total': 'Total to pay',
    'dp.bonus.kpi.linhas': 'Lines',
    'dp.bonus.kpi.linhasDica': '{{pessoas}} people',
    'dp.bonus.kpi.zeradas': 'Zeroed by requirement',
    'dp.bonus.kpi.ajustes': 'Manual adjustments',
    'dp.bonus.kpi.sinistros': 'Accidents reported',
    'dp.bonus.kpi.semValor': 'No value for the model',
    'dp.bonus.porTipo': 'By type',
    'dp.bonus.porFilial': 'By branch',
    'dp.bonus.requisitosNaoCumpridos': 'Unmet requirements',
    'dp.bonus.todosCumpridos': 'Requirements met',
    'dp.bonus.col.pessoa': 'Person',
    'dp.bonus.col.tipo': 'Type',
    'dp.bonus.col.requisitos': 'Requirements',
    'dp.bonus.col.valor': 'Amount',
    'dp.bonus.col.acoes': 'Actions',
    'dp.bonus.todosOsTipos': 'All types',
    'dp.bonus.tipo.operador_hectare': 'Operator bonus',
    'dp.bonus.tipo.adicional_prancha': 'Flatbed allowance',
    'dp.bonus.tipo.adicional_sinistro': 'Accident allowance',
    'dp.bonus.tipo.adicional_manobra': 'Yard allowance',
    'dp.bonus.tipo.adicional_eixos': '{{eixosMinimo}}-axle allowance',
    'dp.bonus.hectares': '{{n}} ha',
    'dp.bonus.diasSeguidos': '{{n}} consecutive days away from base',
    'dp.bonus.diasEixos': '{{n}} days with {{eixosMinimo}} axles or more',
    'dp.bonus.semValorModelo': 'No value for {{modelos}}',
    'dp.bonus.requisito.ponto_assinado': 'Timesheet not signed',
    'dp.bonus.requisito.sem_falta': 'Absence',
    'dp.bonus.requisito.sem_suspensao': 'Suspension',
    'dp.bonus.requisito.sem_infracao_jornada': 'Working-hours violation',
    'dp.bonus.requisito.sem_multa': 'Traffic fine',
    'dp.bonus.requisito.sem_sinistro': 'Accident',
    'dp.bonus.requisito.eixos_cadastrados': 'Axles not registered',
    'dp.bonus.requisitoCumprido.ponto_assinado': 'Timesheet signed',
    'dp.bonus.requisitoCumprido.sem_falta': 'No unjustified absence',
    'dp.bonus.requisitoCumprido.sem_suspensao': 'No suspension',
    'dp.bonus.requisitoCumprido.sem_infracao_jornada': 'No working-hours violation',
    'dp.bonus.requisitoCumprido.sem_multa': 'No traffic fine',
    'dp.bonus.requisitoCumprido.sem_sinistro': 'No accident',
    'dp.bonus.requisitoCumprido.eixos_cadastrados': 'Vehicle axles registered',
    'dp.bonus.fonte': 'Source {{fonte}}',
    'dp.bonus.calculado': 'Calculated {{valor}}',
    'dp.bonus.ajustado': 'Adjusted',
    'dp.bonus.sinistro': 'Accident reported',
    'dp.bonus.ajustar': 'Adjust',
    'dp.bonus.memoria': 'Calculation',
    'dp.bonus.valores': 'Values',
    'dp.bonus.valoresDica': 'The per-hectare value table by machine model, with validity',
    'dp.bonus.ajusteTitulo': 'Adjustment for {{nome}}',
    'dp.bonus.ajusteTipo': '{{tipo}} of {{rotulo}}',
    'dp.bonus.ajusteSinistro': 'Accident reported by the department',
    'dp.bonus.ajusteSinistroExplica': 'A claim entered by Fueling with the driver as the responsible party already breaks the requirement on its own. This mark is for what has not been entered yet: it applies to the whole person in the pay period, zeroes the operator bonus and the accident allowance, and survives recalculation. Removing the mark does not erase an entered claim.',
    'dp.bonus.ajusteValor': 'Amount to pay',
    'dp.bonus.ajusteJustificativa': 'Reason',
    'dp.bonus.ajusteExplica': 'The adjusted amount replaces the calculated one and survives recalculation. Leave it empty to go back to the calculated amount.',
    'dp.bonus.ajusteSalvar': 'Save adjustment',
    'dp.bonus.memoriaTitulo': 'Calculation for {{nome}}',
    'dp.bonus.memoria.tipo': 'Type',
    'dp.bonus.memoria.conta': 'Math',
    'dp.bonus.memoria.requisitos': 'Requirements',
    'dp.bonus.memoria.colheitas': 'Harvests in the period',
    'dp.bonus.memoria.semColheita': 'No harvest measurement in the period',
    'dp.bonus.memoria.hectares': 'Hectares',
    'dp.bonus.memoria.valorHectare': 'Value per hectare',
    'dp.bonus.memoria.semValorModelo': 'No value for the model',
    'dp.bonus.memoria.sequencias': 'Runs away from base',
    'dp.bonus.memoria.maiorSequencia': 'Longest run',
    'dp.bonus.memoria.diasN': '{{n}} days',
    'dp.bonus.memoria.regra': 'Full with {{cheio}} consecutive days; below that, days over {{base}}',
    'dp.bonus.memoria.dias': 'Day by day',
    'dp.bonus.memoria.conta_sim': 'Counts',
    'dp.bonus.memoria.conta_nao': 'Resets',
    'dp.bonus.memoria.jornadas': 'Working days by vehicle',
    'dp.bonus.memoria.eixosN': '{{n}} axles',
    'dp.bonus.memoria.eixosSem': 'Axles not registered',
    'dp.bonus.memoria.valorBruto': 'Amount before requirements',
    'dp.bonus.memoria.ajuste': 'Manual adjustment',
    'dp.bonus.memoria.final': 'Final amount',
    'dp.bonus.memoria.fontes': 'Sources',
    'dp.bonus.memoria.fonteColheita': 'Harvest',
    'dp.bonus.memoria.espelho': '{{rotulo}} timesheet',
    'dp.bonus.memoria.espelhoConferido': 'Checked in the Hub',
    'dp.bonus.memoria.espelhoNaoConferido': 'Not in the Hub',
    'dp.bonus.valoresTitulo': 'Value per hectare by model',
    'dp.bonus.valoresExplica': 'What each harvested hectare pays the operator, by machine model as the fleet registers it. Validity says from when to when the value applies; the line with no end is the one in force. A new value for a model requires ending the previous validity.',
    'dp.bonus.valoresVazia': 'No value registered. The operator bonus stays at zero until the table arrives.',
    'dp.bonus.valores.modelo': 'Model',
    'dp.bonus.valores.modeloDaFrota': 'Fleet model',
    'dp.bonus.valores.modeloLivre': 'Other model',
    'dp.bonus.valores.veiculosN': '{{n}} machines',
    'dp.bonus.valores.valor': 'Value per hectare',
    'dp.bonus.valores.inicio': 'Validity start',
    'dp.bonus.valores.fim': 'Validity end',
    'dp.bonus.valores.observacao': 'Note',
    'dp.bonus.valores.vigente': 'In force',
    'dp.bonus.valores.encerrado': 'Ended',
    'dp.bonus.valores.novo': 'New value',
    'dp.bonus.valores.editar': 'Edit',
    'dp.bonus.valores.retirar': 'Remove',
    'dp.bonus.valores.salvar': 'Save value',
    'dp.bonus.valores.cancelar': 'Cancel editing',
    'dp.bonus.valores.ate': 'until {{data}}',
    'dp.bonus.valores.desde': 'since {{data}}',
    'dp.bonus.valores.lista': 'Registered values',
    'dp.bonus.valores.importar': 'Import spreadsheet',
    'dp.bonus.valores.importarTitulo': 'Import the value per hectare table',
    'dp.bonus.valores.importarExplica': 'The HR spreadsheet with each machine asset number and the value per hectare, attendance already included. Each machine gets the value from 16/09/2026, the first bonus cycle. A machine that already has a value at that start has the value replaced.',
    'dp.bonus.valores.carga.maquinas': 'Machines',
    'dp.bonus.valores.carga.minimo': 'Lowest value',
    'dp.bonus.valores.carga.maximo': 'Highest value',
  },
  es: {
    'dp.bonus.titulo': 'Bonos y adicionales',
    'dp.bonus.eyebrow': 'Departamento de Personal',
    'dp.bonus.apurar': 'Calcular',
    'dp.bonus.reapurar': 'Recalcular',
    'dp.bonus.apurada': 'Cálculo hecho: {{novas}} nuevas, {{recalculadas}} recalculadas.',
    'dp.bonus.naoApurada': 'El período {{rotulo}} aún no fue calculado. Calcular reúne las mediciones de cosecha, la jornada, la diaria de Protheus, las Gestiones, las multas, los siniestros y la hoja de {{espelho}}, y arma el bono del operador y los adicionales de plancha, siniestro, maniobra y ejes.',
    'dp.bonus.explica': 'Bono del operador por la cláusula 4 del acuerdo colectivo: hectáreas cosechadas por el valor por hectárea del modelo de la máquina, anulado por requisito no cumplido. Adicionales de plancha, siniestro y maniobra de {{adicional}}, completos con {{cheio}} días seguidos fuera de la base y proporcionales por debajo. Adicional de {{eixosMinimo}} ejes por la cláusula 3.',
    'dp.bonus.semTabela': 'La tabla de valor por hectárea está vacía. El bono del operador queda en cero hasta que el departamento registre el valor de cada modelo en Valores y recalcule.',
    'dp.bonus.semEspelho': 'La hoja de {{espelho}} no está en el Hub, así que nadie perdió el bono por la firma. Abra el período en Firma de la hoja de asistencia y recalcule.',
    'dp.bonus.antesDoPrazo': 'Hasta el {{prazo}}, quien aún no firmó la hoja de {{espelho}} aparece sin el bono. Recalcule después del plazo.',
    'dp.bonus.kpi.total': 'Total a pagar',
    'dp.bonus.kpi.linhas': 'Líneas',
    'dp.bonus.kpi.linhasDica': '{{pessoas}} personas',
    'dp.bonus.kpi.zeradas': 'Anuladas por requisito',
    'dp.bonus.kpi.ajustes': 'Ajustes manuales',
    'dp.bonus.kpi.sinistros': 'Siniestros informados',
    'dp.bonus.kpi.semValor': 'Sin valor para el modelo',
    'dp.bonus.porTipo': 'Por tipo',
    'dp.bonus.porFilial': 'Por sucursal',
    'dp.bonus.requisitosNaoCumpridos': 'Requisitos no cumplidos',
    'dp.bonus.todosCumpridos': 'Requisitos cumplidos',
    'dp.bonus.col.pessoa': 'Persona',
    'dp.bonus.col.tipo': 'Tipo',
    'dp.bonus.col.requisitos': 'Requisitos',
    'dp.bonus.col.valor': 'Valor',
    'dp.bonus.col.acoes': 'Acciones',
    'dp.bonus.todosOsTipos': 'Todos los tipos',
    'dp.bonus.tipo.operador_hectare': 'Bono del operador',
    'dp.bonus.tipo.adicional_prancha': 'Adicional de plancha',
    'dp.bonus.tipo.adicional_sinistro': 'Adicional de siniestro',
    'dp.bonus.tipo.adicional_manobra': 'Adicional de maniobra',
    'dp.bonus.tipo.adicional_eixos': 'Adicional de {{eixosMinimo}} ejes',
    'dp.bonus.hectares': '{{n}} ha',
    'dp.bonus.diasSeguidos': '{{n}} días seguidos fuera de la base',
    'dp.bonus.diasEixos': '{{n}} días con {{eixosMinimo}} ejes o más',
    'dp.bonus.semValorModelo': 'Sin valor para {{modelos}}',
    'dp.bonus.requisito.ponto_assinado': 'Hoja no firmada',
    'dp.bonus.requisito.sem_falta': 'Falta',
    'dp.bonus.requisito.sem_suspensao': 'Suspensión',
    'dp.bonus.requisito.sem_infracao_jornada': 'Infracción de jornada',
    'dp.bonus.requisito.sem_multa': 'Multa de tránsito',
    'dp.bonus.requisito.sem_sinistro': 'Siniestro',
    'dp.bonus.requisito.eixos_cadastrados': 'Ejes sin registro',
    'dp.bonus.requisitoCumprido.ponto_assinado': 'Hoja de asistencia firmada',
    'dp.bonus.requisitoCumprido.sem_falta': 'Sin falta injustificada',
    'dp.bonus.requisitoCumprido.sem_suspensao': 'Sin suspensión',
    'dp.bonus.requisitoCumprido.sem_infracao_jornada': 'Sin infracción de jornada',
    'dp.bonus.requisitoCumprido.sem_multa': 'Sin multa de tránsito',
    'dp.bonus.requisitoCumprido.sem_sinistro': 'Sin siniestro',
    'dp.bonus.requisitoCumprido.eixos_cadastrados': 'Ejes del vehículo registrados',
    'dp.bonus.fonte': 'Fuente {{fonte}}',
    'dp.bonus.calculado': 'Calculado {{valor}}',
    'dp.bonus.ajustado': 'Ajustado',
    'dp.bonus.sinistro': 'Siniestro informado',
    'dp.bonus.ajustar': 'Ajustar',
    'dp.bonus.memoria': 'Cálculo',
    'dp.bonus.valores': 'Valores',
    'dp.bonus.valoresDica': 'La tabla de valor por hectárea por modelo de máquina, con vigencia',
    'dp.bonus.ajusteTitulo': 'Ajuste de {{nome}}',
    'dp.bonus.ajusteTipo': '{{tipo}} de {{rotulo}}',
    'dp.bonus.ajusteSinistro': 'Siniestro informado por el departamento',
    'dp.bonus.ajusteSinistroExplica': 'El siniestro registrado por Abastecimiento con el conductor como responsable ya incumple el requisito por sí solo. Esta marca es para lo que aún no se registró: vale para toda la persona en el período, anula el bono del operador y el adicional de siniestro, y sobrevive al recálculo. Quitar la marca no borra el siniestro registrado.',
    'dp.bonus.ajusteValor': 'Valor a pagar',
    'dp.bonus.ajusteJustificativa': 'Justificación',
    'dp.bonus.ajusteExplica': 'El valor ajustado reemplaza al calculado y sobrevive al recálculo. Déjelo en blanco para volver al calculado.',
    'dp.bonus.ajusteSalvar': 'Guardar ajuste',
    'dp.bonus.memoriaTitulo': 'Cálculo de {{nome}}',
    'dp.bonus.memoria.tipo': 'Tipo',
    'dp.bonus.memoria.conta': 'Cuenta',
    'dp.bonus.memoria.requisitos': 'Requisitos',
    'dp.bonus.memoria.colheitas': 'Cosechas en el período',
    'dp.bonus.memoria.semColheita': 'Ninguna medición de cosecha en el período',
    'dp.bonus.memoria.hectares': 'Hectáreas',
    'dp.bonus.memoria.valorHectare': 'Valor por hectárea',
    'dp.bonus.memoria.semValorModelo': 'Sin valor para el modelo',
    'dp.bonus.memoria.sequencias': 'Secuencias fuera de la base',
    'dp.bonus.memoria.maiorSequencia': 'Mayor secuencia',
    'dp.bonus.memoria.diasN': '{{n}} días',
    'dp.bonus.memoria.regra': 'Completo con {{cheio}} días seguidos; por debajo, días sobre {{base}}',
    'dp.bonus.memoria.dias': 'Día a día',
    'dp.bonus.memoria.conta_sim': 'Cuenta',
    'dp.bonus.memoria.conta_nao': 'Anula',
    'dp.bonus.memoria.jornadas': 'Jornadas por vehículo',
    'dp.bonus.memoria.eixosN': '{{n}} ejes',
    'dp.bonus.memoria.eixosSem': 'Ejes sin registro',
    'dp.bonus.memoria.valorBruto': 'Valor antes de los requisitos',
    'dp.bonus.memoria.ajuste': 'Ajuste manual',
    'dp.bonus.memoria.final': 'Valor final',
    'dp.bonus.memoria.fontes': 'Fuentes',
    'dp.bonus.memoria.fonteColheita': 'Cosecha',
    'dp.bonus.memoria.espelho': 'Hoja de {{rotulo}}',
    'dp.bonus.memoria.espelhoConferido': 'Verificada en el Hub',
    'dp.bonus.memoria.espelhoNaoConferido': 'No está en el Hub',
    'dp.bonus.valoresTitulo': 'Valor por hectárea por modelo',
    'dp.bonus.valoresExplica': 'Lo que cada hectárea cosechada paga al operador, por modelo de máquina como lo registra la flota. La vigencia dice desde cuándo hasta cuándo vale el valor; la línea sin fin es la vigente. Un valor nuevo de un modelo pide el fin de la vigencia del anterior.',
    'dp.bonus.valoresVazia': 'Ningún valor registrado. El bono del operador queda en cero hasta que llegue la tabla.',
    'dp.bonus.valores.modelo': 'Modelo',
    'dp.bonus.valores.modeloDaFrota': 'Modelo de la flota',
    'dp.bonus.valores.modeloLivre': 'Otro modelo',
    'dp.bonus.valores.veiculosN': '{{n}} máquinas',
    'dp.bonus.valores.valor': 'Valor por hectárea',
    'dp.bonus.valores.inicio': 'Inicio de la vigencia',
    'dp.bonus.valores.fim': 'Fin de la vigencia',
    'dp.bonus.valores.observacao': 'Observación',
    'dp.bonus.valores.vigente': 'Vigente',
    'dp.bonus.valores.encerrado': 'Terminado',
    'dp.bonus.valores.novo': 'Nuevo valor',
    'dp.bonus.valores.editar': 'Editar',
    'dp.bonus.valores.retirar': 'Quitar',
    'dp.bonus.valores.salvar': 'Guardar valor',
    'dp.bonus.valores.cancelar': 'Cancelar edición',
    'dp.bonus.valores.ate': 'hasta {{data}}',
    'dp.bonus.valores.desde': 'desde {{data}}',
    'dp.bonus.valores.lista': 'Valores registrados',
    'dp.bonus.valores.importar': 'Importar planilla',
    'dp.bonus.valores.importarTitulo': 'Importar la tabla de valor por hectárea',
    'dp.bonus.valores.importarExplica': 'La planilla del DP con el número de activo de cada máquina y el valor por hectárea, con la asiduidad incluida. Cada máquina recibe el valor desde 16/09/2026, el primer ciclo del bono. La máquina que ya tiene valor en ese inicio tiene el valor reemplazado.',
    'dp.bonus.valores.carga.maquinas': 'Máquinas',
    'dp.bonus.valores.carga.minimo': 'Menor valor',
    'dp.bonus.valores.carga.maximo': 'Mayor valor',
  },
}
